import { useProductsByStudioIdQuery } from "entities/products/queries/useProductsByStudioIdQuery";
import { useStudiosPage } from "modules/studios/context";
import { FC } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import TableWithPagination from "shared/components/TableWithPagination";
import { studioProductsColumns } from "../../helpers";

const ProductsList: FC = () => {
  const { studioDetailsDrawer, productDetailsDrawer } = useStudiosPage();

  const { data = [], isLoading } = useProductsByStudioIdQuery(
    studioDetailsDrawer.drawerDetails?.id,
  );

  const columns = studioProductsColumns({
    handleAction: productDetailsDrawer.openDrawer,
  });

  return (
    <ContentSection title="Products">
      <TableWithPagination
        data={data}
        columns={columns}
        hideFooter
        heightTable={"auto"}
        minHeight={"180px"}
        sortingMode="client"
        loading={isLoading}
        emptyStateMessage="Not found"
      />
    </ContentSection>
  );
};

export default ProductsList;
